'use strict';

angular.module('buyers')
.directive('mainMenu', ['$location', function($location) {
    return {
        templateUrl : "partials/main-menu.html",
        restrict: 'E', // attribute
        link : function (scope, element, attrs) {
            $('.main-menu').dropdown();
        }
    };
}]);